export default __webpack_public_path__ + "static/media/logo.2ae5b11185f361983b8ff9d599fc7a4b.svg";